import { createBrowserRouter } from "react-router-dom";
import { Home } from "../components/Home";
import App from "../App";
import {BudgetRequestForm} from "../components/Form";
import { BudgetReqDraft } from "../components/FormDraft";
import { BudgetReqInfo } from "../components/BudgetReqInfo";
import { BudgetreqAbout } from "../components/BudgetReqAbout";
import { BudgetReqResearcher } from "../components/BudgetReqResearcher";
import { BudgetReqDetail } from "../components/BudgetDetail";
import { BudgetReqResult } from "../components/BudgetReqResult";
import { BudgetReqFund } from "../components/BudgetReqFund";
import {Test} from "../components/Test";

import { ReqInfo } from "../components/budgetReq";
import { SelectRole } from "../components/selectRole";
import { StaffBudgetReq } from "../components/BudReqInfoStaff";
import { CommitteeReqInfo } from "../components/CommitteeReq";
import { ProgressReport } from "../components/ResearcherReport/ProgressReport";
import { CompletionReport } from "../components/ResearcherReport/CompletionReport";
import { ProgressReportCheck } from "../components/ResearcherReport/ProgressReportCheck";
import { CompletionReportCheck } from "../components/ResearcherReport/CompletionReportCheck";
import { StaffCompletionReport } from "../components/StaffReport/StaffCompletion";
import { StaffReportList } from "../components/StaffReport/StaffReportList";
import { StaffProgressCheck } from "../components/StaffReport/StaffProgressCheck";
import { PorgressReportEdit } from "../components/ResearcherReport/ProgressReportEdit";
import { StaffReportDashboard } from "../components/StaffReport/StaffReportDashboard";
import { CompletionReportStaffReview } from "../components/StaffReport/StaffCompletionReportCheck";

export const router = createBrowserRouter([
    {
        path:"/VRIIS",
        element: <App />,
        children : [
            {path : "/VRIIS/", element : <Home/>},
            {path : "/VRIIS" , element : <Home/>},
            {path : "/VRIIS/selectRole", element :<SelectRole/>},
            {path : "/VRIIS/BudgetRequestForm" , element : <BudgetRequestForm/>},
            {path : "/VRIIS/BudgetReqDraft", element : <BudgetReqDraft/>},
            {path : "/VRIIS/BudgetReqInfo/:project_id", element : <BudgetReqInfo/>},
            {path : "/VRIIS/Budget_req_About/:project_id", element : <BudgetreqAbout/>},
            {path : "/VRIIS/BudgetReqResearcher/:project_id", element : <BudgetReqResearcher/>},
            {path : "/VRIIS/BudgetReqDetail/:project_id", element : <BudgetReqDetail/>},
            {path : "/VRIIS/BudgetReqResult/:project_id", element : <BudgetReqResult/>},
            {path : "/VRIIS/BudgetReqFund/:project_id", element : <BudgetReqFund/>},
            {path : "/VRIIS/ProgressReport/:project_id", element : <ProgressReport/>},
            {path : "/VRIIS/ProgressReportCheck/:project_id", element : <ProgressReportCheck/>},
            {path : "/VRIIS/ProgressReportEdit/:project_id/:progress_id", element : <PorgressReportEdit/>},
            {path : "/VRIIS/CompletionReport/:project_id", element : <CompletionReport/>},
            {path : "/VRIIS/CompletionReportCheck/:project_id", element : <CompletionReportCheck/>},

            {path : "/VRIIS/test", element : <Test/>},

            {path : "/VRIIS/ReqInfo/:user/:project_id", element : <ReqInfo/>},
            {path : "/VRIIS/StaffBudgetReq/:user/:project_id", element : <StaffBudgetReq/>},
            {path : "/VRIIS/CommitteeReqInfo/:user/:project_id", element : <CommitteeReqInfo/>},

            {path : "/VRIIS/ProgressReportList", element : <StaffReportList/>},
            {path : "/VRIIS/CompletionReportStaffCheck", element : <StaffCompletionReport/>},
            {path : "/VRIIS/ProgressReportReview/:progress_id", element : <StaffProgressCheck/>},
            {path : "/VRIIS/CompletionReportReview/:progress_id",element: <CompletionReportStaffReview/>},
            {path:  "/VRIIS/StaffReportDashboard" , element:<StaffReportDashboard/>}
            
        ]
    }
])